import { saveState, getSavedState } from '@utils/browser-help'
import moment from 'moment'
import { debounce } from 'lodash';

export default {
    components: {

    },
    filters: {
    },
    data() {
        return {

        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        /**
     * @description 將一串長的spec_tag 分開，變成可以顯示的格式
     */
    converSpecTagStr(specLongTag) {
        try {
          // 首先使用逗号分割字符串
          let parts = specLongTag.split(",");
          // 创建一个空数组来存储容量信息
          let oriCutArr = [];
          // 循环处理每个部分
          for (let i = 0; i < parts.length; i++) {
            let part = parts[i];
            let splitPart = part.split(":"); // 使用冒号分割部分并将结果存储为一个数组
            if (splitPart.length === 2) {
              let extractedText = []; // 如果成功分割成两个元素，将其添加到容量信息数组中
              for (let i = 0; i < splitPart.length; i++) {
                // 循环处理每个元素
                let element = splitPart[i];
                let match = element.match(/(.*)spec/); // 使用正则表达式匹配 "spec" 之前的文字
                if (match) {
                  extractedText.push(match[1]); // 如果匹配成功，将提取的文字添加到新数组中
                }
              }
              oriCutArr.push(extractedText);
            }
          }
          return oriCutArr;
        } catch (error) {
          console.error(error.message);
        }
      },
        /**
         * @description 獲取下拉選單
         */
        async fetchSelectLeaf() {
            try {
                const result = await this.$store.dispatch('product/fetchServiceCategoryForLeaf', {
                    type: 'goods',
                    onlyLeaf: 1
                })
                this.leafOption = result
            } catch (error) {
                console.error(error.message)
            }
        },
    }
}